import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@nimbus-ds/components';
import { getIsMobileDevice } from '@tiendanube/nexo';
import AppLayout from 'App/components/AppLayout';
import nexo from 'App/nexoClient';
import { ROUTES } from 'App/Routes/constants';
import { RenderByCountry } from 'commons/components';
import { useBackLink } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import ConfigurationArgentina from './Argentina/ConfigurationArgentina';
import ConfigurationMexico from './Mexico/ConfigurationMexico';
import ConfigurationSkeleton from './ConfigurationSkeleton';

function Configuration(): JSX.Element {
  const { t } = useTranslationWithPrefix('configuration');

  const [redirectPath, setRedirectPath] = useState('');
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  const { backLink: backLinkState } = useBackLink();
  const backLink = useMemo(() => {
    return {
      path: backLinkState.backLinkPath,
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    const getRedirectPath = async () => {
      const isMobileDevice = await getIsMobileDevice(nexo);
      if (isMobileDevice) {
        setRedirectPath(ROUTES.HOME);
        setIsMobileDevice(true);
      } else {
        setRedirectPath(backLink.path ?? 'payments');
        setIsMobileDevice(false);
      }
    };
    getRedirectPath();
  }, [backLink.path]);

  return (
    <AppLayout
      title={t('title')}
      backLinkPath={redirectPath}
      backLinkText={t('backLinkText')}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap="6"
        alignItems="stretch"
        data-testid="configuration"
      >
        <RenderByCountry
          AR={<ConfigurationArgentina />}
          MX={<ConfigurationMexico />}
        />
      </Box>
    </AppLayout>
  );
}

Configuration.Skeleton = ConfigurationSkeleton;
export default Configuration;
